import React from 'react';
import { MenuItemLink, WithPermission } from 'admin-on-rest'
import UserIcon from 'material-ui/svg-icons/social/group'
import { DealerIcon } from './Dealers'
import { BankIcon } from './Banks'
import { userIs } from './util'
import Avatar from 'material-ui/Avatar'
import md5 from 'md5'
import MapsDirectionsCar from 'material-ui/svg-icons/maps/directions-car';
import ContentSend from 'material-ui/svg-icons/content/send';
import ActionDescription from 'material-ui/svg-icons/action/description';
import ActionAssignmentTurnedIn from 'material-ui/svg-icons/action/assignment-turned-in'
import ActionDone from 'material-ui/svg-icons/action/done'
import ActionBook from 'material-ui/svg-icons/action/book'
import ActionDoneAll from 'material-ui/svg-icons/action/done-all'
import ActionCreditCard from 'material-ui/svg-icons/action/credit-card'
import { stringify } from 'query-string'
import { Link } from 'react-router-dom'
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'
import Subheader from 'material-ui/Subheader'

const userType = () => {
	let loggedUser = []
	if ( userIs( 'collector' ) ) {
		loggedUser.push( 'Collector' )
	} else if ( userIs( 'dc' ) ) {
		loggedUser.push( 'DC' )
	}
	if ( userIs( 'sales_support_head' ) ) {
		loggedUser.push( ' Sales Support Head' )
	}
	if ( ! loggedUser.length ) {
		loggedUser.push( 'nobody' )
	}
	return loggedUser.join( ' & ' )
}

const avatarHash = () => {
	const email = localStorage.getItem('email');
	if ( ! email ) {
		return '';
	}
	return md5(email)
}

const name = () => localStorage.getItem('name') || localStorage.getItem('email');

const getFilterURL = (path, filterObject, perPage = 25, hash = '') => (
	{
		pathname: `/${path}`, ///accounts_support_head',
		search: stringify({ page: 1, perPage, filter: JSON.stringify(filterObject) }),
		hash
	}
)

export default ({ resources, onMenuTap, logout }) => {

	return (
    <div className="ar-menu">
		<div style={{ textAlign: 'center', margin: '32px 16px' }}>
			<Avatar src={`https://www.gravatar.com/avatar/${avatarHash()}?s=160`} style={{ display: 'block', margin: '16px auto', width: 80, height: 80 }}/>
			{name()}
			<span style={{ fontSize: '.8em', marginTop: 5, opacity: 0.6, fontStyle: 'italic', display: 'block' }}>Logged in as {userType()}</span>
		</div>
		<Divider />
		<WithPermission resolve={ ({ permissions }) => permissions.role.includes( 'dc' ) }>
			<Subheader>DC Accounts</Subheader>
			<MenuItem containerElement={<Link to={getFilterURL( 'accounts', {})} />} primaryText="Current Accounts" leftIcon={<UserIcon/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {pending_docs: 'has_pending_docs'})} primaryText="Current Accounts w/ Pending Docs" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {doc_def: 'has_doc_def'})} primaryText="Current Accounts w/ Doc Def" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {time: 'current_month', released: 'released'})} primaryText="All Accounts Released" leftIcon={<MapsDirectionsCar/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {time: 'current_month', transmitted: 'transmitted'})} primaryText="All Accounts Transmitted" leftIcon={<ContentSend/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {time: 'current_month', doc_def: 'had_doc_def'})} primaryText="All Accounts w/ Doc Def" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			<MenuItemLink to={getFilterURL( 'accounts', {time: 'current_month', released: 'released_with_pending_docs'})} primaryText="All Accounts Released w/ Pending Docs" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
        	<MenuItemLink to="/dealerships" primaryText="Dealerships" leftIcon={<DealerIcon/>} onClick={onMenuTap} />
        	<MenuItemLink to="/banks" primaryText="Banks" leftIcon={<BankIcon/>} onClick={onMenuTap} />
			<Divider />
		</WithPermission>
		<WithPermission resolve={ ({ permissions }) => permissions.role.includes( 'collector' ) }>
			<Subheader>Collector Accounts</Subheader>
        	<MenuItemLink to={getFilterURL( 'accounts', {})} primaryText="Current Accounts" leftIcon={<UserIcon/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {status_: 'review'})} primaryText="Current Accounts - Review" leftIcon={<ActionAssignmentTurnedIn/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {status_: 'booking'})} primaryText="Current Accounts - Booking" leftIcon={<ActionBook/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {status_: 'for_collection'})} primaryText="Current Accounts - For Collection" leftIcon={<ActionCreditCard/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {doc_def: 'has_doc_def'})} primaryText="Current Accounts w/ Doc Def" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {status_: 'proceeds_collected', time: 'all'})} primaryText="All Accounts w/ Proceeds Collected" leftIcon={<ActionDone/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {status_: 'di_collected', time: 'all'})} primaryText="All Accounts w/ DI Collected" leftIcon={<ActionDoneAll/>} onClick={onMenuTap} />
        	<MenuItemLink to={getFilterURL( 'accounts', {doc_def: 'had_doc_def', time: 'all'})} primaryText="All Accounts w/ Doc Def" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
        	<MenuItemLink to="/banks" primaryText="Banks" leftIcon={<BankIcon/>} onClick={onMenuTap} />
        	<MenuItemLink to="/dealerships" primaryText="Dealerships" leftIcon={<DealerIcon/>} onClick={onMenuTap} />
			<Divider />
		</WithPermission>
		<WithPermission resolve={ ({ permissions }) => permissions.role.includes( 'sales_support_head' ) }>
			<Subheader>Sales Support Head</Subheader>
			<MenuItem containerElement={<Link to={getFilterURL( 'accounts_support_head_transmittal', { released: 'released', transmitted: 'not_transmitted' } )} />} primaryText="Pending Transmittal" leftIcon={<MapsDirectionsCar/>} onClick={onMenuTap} />
			<MenuItem containerElement={<Link to={getFilterURL( 'accounts_support_head_doc_def', { doc_def: 'has_doc_def' } )} />} primaryText="Pending Doc Def" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			<Divider />
		</WithPermission>
		<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'sales_support_team_incentive' ) || permissions.reports.includes( 'cc_officer_incentive' ) }>
			<Subheader>Incentive Reports</Subheader>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'sales_support_team_incentive' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_sales_support_team_incentive' )} />} primaryText="Sales Support Team Incentive" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'cc_officer_incentive' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_cc_officer_incentive' )} />} primaryText="C&C Officer Incentive" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<Divider />
		</WithPermission>
		<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'collections' ) || permissions.reports.includes( 'bank_collections' ) }>
			<Subheader>AR & Collection Reports</Subheader>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'collections' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_collections_dealership', {}, 100 )} />} primaryText="Collections Overview by Dealership" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
				<MenuItem containerElement={<Link to={getFilterURL( 'report_collections_bank', {}, 100 )} />} primaryText="Collections Overview by Bank" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
				<MenuItem containerElement={<Link to={getFilterURL( 'report_ar_report_release', {}, 100 )} />} primaryText="Monthly AR Based on Release" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
				<MenuItem containerElement={<Link to={getFilterURL( 'report_ar_report', {}, 100 )} />} primaryText="Monthly AR Based on Date to Bank" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'bank_collections' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_bank', {}, 100 )} />} primaryText="Bank Report" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<Divider />
		</WithPermission>
		<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'documentation_performance' ) || permissions.reports.includes( 'dealership_performance' ) }>
			<Subheader>Performance Reports</Subheader>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'dealership_performance' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_dealership_performance', {}, 100)} />} primaryText="Dealership Performance Overview" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'documentation_performance' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_documentation_performance', {}, 100 )} />} primaryText="Documentation Performance" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'documentation_performance' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_collection_performance', {}, 100 )} />} primaryText="Collection Performance" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<WithPermission resolve={ ({ permissions }) => permissions.reports.includes( 'documentation_performance' ) }>
				<MenuItem containerElement={<Link to={getFilterURL( 'report_collection_status', {}, 100 )} />} primaryText="Collection Status" leftIcon={<ActionDescription/>} onClick={onMenuTap} />
			</WithPermission>
			<Divider />
		</WithPermission>
        {logout}
    </div>
	)
}



// WEBPACK FOOTER //
// ./src/Menu.js